import { cn } from '@invent/wl-ui-kit-next';
import * as React from 'react';

/**
 * The sentence beside a control the reader's authority does not reach (SR-228's R3, the design
 * `docs/superpowers/specs/2026-10-05-role-model-ui.md` §4): the control stays drawn, disabled,
 * and this says why — "Your Team Portal roles do not include <what>." A section the reader cannot
 * open is hidden instead; this is for a press inside one they can see.
 *
 * **The words are handed in by the domain**, as `<what>`: the design system knows no permission
 * and names no screen's act, and the mapping of a press to the permission behind it is survey-api's
 * policy, read in the domain. It decides nothing — the caller draws it where `can()` says no.
 *
 * **Visible text, never a `title`**: a tooltip reaches neither a keyboard nor a touch screen, and
 * a disabled button is skipped by both. `id` lets the caller point the control's
 * `aria-describedby` at it, so the reason is read with the control too. `data-not-permitted` is
 * what a spec reads.
 */
export function NotPermitted({
  what,
  id,
  className
}: {
  /** What the press does, lower-case and without a full stop: "deciding a work item". */
  what: string;
  id?: string;
  className?: string;
}) {
  return (
    <p data-not-permitted id={id} className={cn('text-sm text-muted-foreground', className)}>
      Your Team Portal roles do not include {what}.
    </p>
  );
}
